import { useTranslation } from "next-i18next";
import { Box, ListItem, UnorderedList, VStack } from "@chakra-ui/react";
import { Container } from "@looksrare/uikit";
import { Text } from "uikit";
import Accordion, { AccordionLabel } from "components/Accordion";

const accordionSharedProps = {
  buttonProps: {
    borderRadius: "none",
    borderBottomLeftRadius: "none",
    borderBottomRightRadius: "none",
    _hover: {
      borderRadius: "none",
      borderBottomLeftRadius: "none",
      borderBottomRightRadius: "none",
      bg: "hover-interactive-02",
    },
    _active: {
      bg: "onclick-interactive-02",
    },
  },
  panelProps: {
    borderRadius: "none",
  },
};

const answerTextProps = {
  textStyle: "detail",
  color: "text-03",
};

export const Faq = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="1200px">
      <Text textStyle="heading-03" bold mb={6}>
        FAQs
      </Text>
      <VStack pb={16}>
        <Box borderRadius="container" overflow="hidden" width="100%">
          <Accordion
            leftButtonElement={
              <AccordionLabel color="text-01">{t("Who can participate in the Affiliate Program?")}</AccordionLabel>
            }
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "In the initial stages, we’re partnering with the thought leaders and platforms with a vast audience. We’ll initially consider applications on a case-by-case basis. Depending on demand, we may open it up further."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={
              <AccordionLabel textAlign="left" color="text-01">
                {t("What is considered an ‘interaction’ from a referral?")}
              </AccordionLabel>
            }
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "For one of your referred users to become ‘active’, they need to perform one of the following actions within their first 30 days of following your referral link:"
              )}
              <UnorderedList>
                <ListItem {...answerTextProps}>{t("Create a listing")}</ListItem>
                <ListItem {...answerTextProps}>{t("Bid on an item")}</ListItem>
                <ListItem {...answerTextProps}>{t("Buy an NFT")}</ListItem>
              </UnorderedList>
              {t(
                "If they don’t, the ‘link’ will expire and they’ll be eligible to be referred by others. If they do, great! Their address will be tied to your affiliate account for the forseeable future."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={
              <AccordionLabel color="text-01">{t("What affiliate activities earn ETH rewards?")}</AccordionLabel>
            }
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "If your referrals make an offer on an item or list an NFT for sale, you'll earn your reward once these actions are 'converted' — in other words, when the offer is accepted or the NFT is purchased."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={<AccordionLabel color="text-01">{t("How do I receive my ETH?")}</AccordionLabel>}
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "When you enroll, we’ll ask you for an ETH address. We’ll pay all commissions generated from your referrals’ activity here."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={<AccordionLabel color="text-01">{t("When/how are payments made?")}</AccordionLabel>}
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "Your ETH rewards are paid out on-chain and in real-time whenever your affiliate completes an eligible transaction."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={<AccordionLabel color="text-01">{t("How do I get my login details?")}</AccordionLabel>}
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "You don't need them. To access your dashboard, just provide a signature from your whitelisted address."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={<AccordionLabel color="text-01">{t("How do affiliate links work?")}</AccordionLabel>}
            {...accordionSharedProps}
          >
            <Text {...answerTextProps}>
              {t(
                "When you join the program, you'll get a custom string (e.g ?ref=12345) which you can append to any LooksRare URL. This ID is tied to your wallet, and lets us know when you've referred a user. You can access it via the Affiliate Dashboard."
              )}
            </Text>
          </Accordion>
          <Accordion
            leftButtonElement={
              <AccordionLabel color="text-01">{t("Where can I get my referral links?")}</AccordionLabel>
            }
            {...accordionSharedProps}
            //override shared borderBottomRadius
            panelProps={{}}
          >
            <Text {...answerTextProps}>
              {t(
                "When you’re accepted, you’ll get access to your very own Affiliate Dashboard. Here, you can generate links and track your progress."
              )}
            </Text>
          </Accordion>
        </Box>
      </VStack>
    </Container>
  );
};
